import { render, staticRenderFns } from "./breachContract.vue?vue&type=template&id=8a34f684&scoped=true"
import script from "./breachContract.vue?vue&type=script&lang=js"
export * from "./breachContract.vue?vue&type=script&lang=js"
import style0 from "./breachContract.vue?vue&type=style&index=0&id=8a34f684&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a34f684",
  null
  
)

export default component.exports